// Simple spinner — we never show a blank screen while loading (frontend convention).
interface SpinnerProps {
  className?: string;
}

export function Spinner({ className = 'w-4 h-4' }: SpinnerProps) {
  return (
    <svg className={'animate-spin ' + className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2.4" className="opacity-20" />
      <path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
}
